const GET_AZURE_METRICS_LOGS = "GET_AZURE_METRICS_LOGS";
const GET_AZURE_METRICS_LOGS_SUCCESS = "GET_AZURE_METRICS_LOGS_SUCCESS";
const GET_AZURE_METRICS_LOGS_ERROR = "GET_AZURE_METRICS_LOGS_ERROR";

export {
  GET_AZURE_METRICS_LOGS,
  GET_AZURE_METRICS_LOGS_SUCCESS,
  GET_AZURE_METRICS_LOGS_ERROR,
};
